import { CloseIcon, Stack, styled, TickIcon, Tooltip } from 'canoe';
import React from 'react';

import { useTraitMatches, VariableMatch } from './useTraitMatches';

const Variable = styled.div`
  font-size: 12px;
  font-family: 'sofia-pro', sans-serif;
  font-weight: 400;
  font-style: normal;
`;

const VariableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FallbackRow = styled.div``;

interface VariableSummaryProps {
  url: string;
}

const UserTraitRow = ({ name, matchesTrait, fallback }: VariableMatch) => {
  return (
    <Variable>
      <VariableRow>
        <div>Trait: {name}</div>
        {matchesTrait === true && (
          <Tooltip placement="top" content="This User Trait exists">
            <TickIcon color="Success" size="s" />
          </Tooltip>
        )}
        {matchesTrait === false && (
          <Tooltip placement="top" content="This User Trait does not exist">
            <CloseIcon color="Danger" size="xs" />
          </Tooltip>
        )}
      </VariableRow>
      {fallback ? <FallbackRow>Fallback: {fallback}</FallbackRow> : undefined}
    </Variable>
  );
};
const UrlPartRow = ({ name, fallback }: VariableMatch) => {
  const isPlural = name.includes('[');

  const tooltip = (() => {
    switch (true) {
      case name.startsWith('protocol'):
        return 'The protocol of the URL';
      case name.startsWith('hostname'):
        return isPlural ? 'A section of the URL hostname, 0 indexed' : 'The hostname of the URL';
      case name.startsWith('pathname'):
        return isPlural ? 'A section of the URL pathname, 0 indexed' : 'The current URL path';
      case name.startsWith('search'):
        return isPlural
          ? 'Named URL search parameter'
          : 'All URL search parameters, without leading ?';
      default:
        return '';
    }
  })();

  return (
    <Variable>
      <VariableRow>
        <div>URL: {name}</div>
        {tooltip ? (
          <Tooltip placement="top" content={tooltip}>
            <TickIcon color="Success" size="s" />
          </Tooltip>
        ) : undefined}
      </VariableRow>
      {fallback ? <FallbackRow>Fallback: {fallback}</FallbackRow> : undefined}
    </Variable>
  );
};

export const VariableSummary = ({ url }: VariableSummaryProps) => {
  const matches = useTraitMatches(url);

  if (!url || !matches || matches.length === 0) {
    return <></>;
  }
  return (
    <Stack spaceAfter="xs">
      {matches.map((variable, i) => {
        if (variable.type === 'user') {
          return <UserTraitRow key={`${i.toString()}`} {...variable} />;
        }
        return <UrlPartRow key={`${i.toString()}`} {...variable} />;
      })}
    </Stack>
  );
};
